import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'



import weightLossFormNew from '@/components/WeightLoss/weightLossFormNew.vue';
import WeightLossFlowTwo from '@/components/WeightLoss/WeightLossFlowTwo.vue';

import reportPage from '@/components/WeightLoss/reportPage.vue';

import choosePlan from '@/components/checkouts/chooseMeds.vue';
import checkoutWeightLoss from '@/components/checkouts/checkoutWeightLoss.vue';
import checkoutCallCenter from '@/components/checkouts/checkoutCallCenter.vue';
import prescriptionThanks from '@/components/checkouts/WeightLossAfterCheckout.vue';
import showStepsToUser from '@/components/WeightLoss/showStepsToUser.vue';
import verifyPhoneAndEmail from '@/components/WeightLoss/verifyPhoneAndEmail.vue';

import uploadVideo from '@/components/forms/uploadVideo.vue';

import replaceRequest from '@/components/reshiping/replaceRequest.vue';

import formLoader from '@/components/forms/formLoader.vue';
import adjustDoases from '@/components/forms/AdjustDoases.vue';

import prescriptionView from '@/components/forms/prescriptionView.vue';

import HomePage from '@/components/dashboard/HomePage.vue'
import leadDisqualified from '@/components/common/leadDisqualified.vue';
import LoginPage from '@/components/auth/LoginPage.vue';
import ResetPassword from '@/components/auth/ResetPassword.vue'
import ForgotPassword from '@/components/auth/ForgotPassword.vue'



Vue.use(Router)

const router = new Router({
  mode: 'history',
  hash: false,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved scroll position (like after navigating back), use it
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'WeightLossFlowTwoHome',
      component: weightLossFormNew,
      meta: {
        requiresAuth: false,
        guest: true
      }
      
    },
    {
      path: '/sign-up',
      name: 'WeightLossFlowTwoOld',
      component: WeightLossFlowTwo,
      meta: {
        requiresAuth: false,
        guest: true
      }
      
    },
    {
      path: '/weight-loss-plan',
      name: 'chooseWPlan',
      component: choosePlan,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/select-med',
      name: 'choosePlan',
      component: choosePlan,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/upload-video/:id',
      name: 'uploadVideo',
      component: uploadVideo,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
     {
      path: '/weight-loss-payment/:cart_id',
      name: 'checkoutWeightLoss',
      component: checkoutWeightLoss,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weightlosspayment/:cart_id',
      name: 'checkoutCallCenter',
      component: checkoutCallCenter,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-report',
      name: 'reportPage',
      component: reportPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
   {
      path: '/payment/thanks',
      name: 'prescriptionThanks',
      component: prescriptionThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/replacement-request',
      name: 'replaceRequest',
      component: replaceRequest,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
     {
      path: '/status-progress',
      name: 'showStepsToUser',
      component: showStepsToUser,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/verify',
      name: 'verifyPhoneAndEmail',
      component: verifyPhoneAndEmail,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/home',
      name: 'HomePage',
      component: HomePage,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/prescription/:id',
      name: 'prescriptionView',
      component: prescriptionView,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/adjust-doses/:id',
      name: 'adjustDoases',
      component: adjustDoases,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/medical-form/:id',
      name: 'QuestionFormLoaderUpdated',
      component: formLoader,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },   
    {
      path: '/sorry',
      name: 'leadDisqualified',
      component: leadDisqualified,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/password-reset/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },   
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.authToken !== null;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authToken == null) {
      // Add the page_ref query parameter with the route name the user was trying to access
      next({
        path: '/login',
        query: {
          page_ref: to.fullPath,
        }
      });
    } else {
      next();
    }
  }else if (to.path === '/login' && isAuthenticated) {
    next('/home'); 
  } else {
    next();
  }
})

export default router;
